// extracted by mini-css-extract-plugin
export default {"section":"OrderFeedItem_section__YMIXe"};